<template>
  <section id="contact" v-appear="{ delay: 200 }" class="layout-section -top home-newsletter">
    <p class="layout-section__toptitle">{{ $t('home.newsletter') }}</p>

    <form class="home-newsletter__form">
      <input type="text" class="input" />
      <button class="button">Subscribe</button>
      <iframe :src="`/newsletter-form-${$i18n.locale}.html`" frameborder="0" class="home-newsletter__frame" />
    </form>
  </section>
</template>

<script>
export default {
  name: 'HomeNewsletter'
}
</script>
